module.exports = __webpack_public_path__ + "static/img/logo_header.948b0bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_header.svg
// module id = 449
// module chunks = 2